import { forwardRef } from "react"
import { BaseIconButton } from "./styles"

export interface IconButtonProps extends React.ComponentPropsWithRef<"button"> {
  color?: "primary" | "default" | "danger" | "warning" | "success"
  variant?: "default" | "outlined" | "contained" | "dashed"
  size?: "xsmall" | "small" | "default" | "large" | "xlarge"
}

const iconSize = {
  xsmall: "caption",
  small: "caption",
  default: "body",
  large: "subheader",
  xlarge: "subheader",
}
const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      children,
      color = "default",
      variant = "default",
      size = "small",
      className = "",
      ...props
    },
    ref
  ) => {
    return (
      <BaseIconButton
        ref={ref}
        className={`
        color--${color} variant--${variant}
        size--${size}
        ${iconSize[size]}
        ${className}
      `}
        {...props}
      >
        {children}
      </BaseIconButton>
    )
  }
)

IconButton.displayName = "IconButton"

export default IconButton
